import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { CreditosService } from 'src/app/services/creditos/creditos.service';
import { ListasService } from 'src/app/services/listas/listas.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { ParametrosGeneralesService } from 'src/app/services/parametrosgenerales/parametrosgenerales.service';
@Component({
  selector: 'app-maincliente',
  templateUrl: './maincliente.component.html',
  styleUrls: ['./maincliente.component.css']
})
export class MainclienteComponent implements OnInit {
  uid = localStorage.getItem('uid');
  customer = {id: ''};
  customer_credits = [];
  credit_status = [];
  lists = [];
  cols = [

    { field: 'credit_folio', header: 'Folio', moneda: false },
    { field: 'created_at', header: 'Fecha solicitud', moneda: false },
    { field: 'total_requested', header: 'Pedido Total', moneda: true },
    { field: 'interests', header: 'Intereses', moneda: true },
    { field: 'total_debt', header: 'Adeudo Total', moneda: false },
    { field: 'status', header: 'Estado', moneda: false },
  ];
   indicadorPosicion: string;
   creditoYucatan = false;

  // CREDITOS-REVOLVENTES: si el parámetro CREDITO_REVOLVENTE está en SI y el cliente
  // ya tiene un crédito revolvente activo, al solicitar un "segundo crédito" (la
  // reestructuración) se va directo a la solicitud sin volver a capturar datos/documentos.
  creditoRevolventeActivo = false;
  tieneRevolventeActivo = false;

  constructor(private route: ActivatedRoute,
    private usuarioService: UsuarioService,
    private creditosService: CreditosService,
    private listasService: ListasService,
    private parametrosService: ParametrosGeneralesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // CREDITOS-REVOLVENTES: leer el parámetro general que activa el feature.
    this.parametrosService.getParametros().subscribe((params: any[]) => {
      const pRevolvente = params.find(p => p.key === 'CREDITO_REVOLVENTE');
      this.creditoRevolventeActivo = !!pRevolvente && (pRevolvente.value || '').toString().toUpperCase() === 'SI';
    }, err => {
      console.log('No se pudieron leer los parámetros de créditos revolventes', err);
    });

    var observableCustomer = this.usuarioService.getCustomer(this.uid);
    var creditos = this.creditosService.getCredits();
    var status = this.listasService.getListsByDomain('CREDIT_STATUS');
    forkJoin([observableCustomer, creditos, status]).subscribe(([customer, creditos, status]) => {
      var allCredits = [];
      Object.keys(status['data']).forEach(k => {
        this.credit_status.push(status['data'][k].attributes);
      });
      Object.keys(creditos['data']).forEach(key => {
          let credit = creditos['data'][key].attributes;
          try{
            let status = this.credit_status.find(s => s.key == credit.status);
            credit.status = status.value;
          }catch{}
          allCredits.push(credit);
        })
      this.customer = customer['data'].relations.customers[0].attributes;
      this.customer_credits = allCredits.filter(credito => credito.customer_id === this.customer.id && credito.status != 'REVISADO' && credito.status != 'LIQUIDADO' && credito.status != 'RECHAZADO');;
      console.log(this.customer_credits);

      // CREDITOS-REVOLVENTES: ¿el cliente ya tiene un crédito revolvente activo?
      // (de la lista ya filtrada). Se usa para saltar la captura de datos/documentos.
      this.tieneRevolventeActivo = this.customer_credits.some(c => c.revolving_credit === true);

      if(this.customer_credits.length == 0){
        this.router.navigate([`/maincliente/solicitudcredito`]);
      }
    })
  }

  completaInfo(){
    // CREDITOS-REVOLVENTES: si es una reestructuración (parámetro en SI y el cliente
    // ya tiene un crédito revolvente activo), se va DIRECTO a la solicitud de crédito
    // sin volver a capturar datos ni documentos (ya los tiene de su crédito previo).
    // En cualquier otro caso (crédito no revolvente) se mantiene el flujo normal:
    // pasar por la captura de datos/documentos.
    if (this.creditoRevolventeActivo && this.tieneRevolventeActivo) {
      this.router.navigate([`/maincliente/solicitudcredito`]);
    } else {
      this.router.navigate([`/modregemp/det/${this.uid}/c`]);
    }
  }

}
